import PersonelsUtils from '../../utils/PersonelsUtils';
import RequestManagement from './RequestManagementNavigation';
import store from '../../store';
import isMobile from 'ismobilejs';
class Parent {
    
    static NavProfile = {
        id: "nav-profile",
        title: "nav-profile",
        icon: "mdi-account",
        to: "profile",
        subItems: [],
        order: 1,
    };

    static NavLogout = {
        id: "nav-logout",
        title: "nav-logout",
        icon: "",
        to: "",
        subItems: [],
        order: 100,
    };

    static NavIO = {
        id: "nav-io",
        title: "nav-io",
        icon: "mdi-transit-transfer",
        to: "",
        subItems: [],
        order: 2,
    };

    static NavFunctinality = {
        id: "nav-functionality",
        title: "nav-functionality",
        icon: "mdi-poll",
        to: "",
        subItems: [],
        order: 3,
    };

    static NavMyRequest = {
        id: "nav-my-request",
        title: "nav-my-request",
        icon: "mdi-order-bool-descending-variant",
        to: "",
        subItems: [],
        order: 4,
    };

    static NavPersonelOperationReport = {
        id: "nav-personel-operation-report",
        title: "nav-personel-operation-report",
        icon: "mdi-chart-areaspline",
        to: "",
        subItems: [],
        order: 8,
    };

    static NavRequestManagement = {
        id: "nav-request-managment",
        title: "nav-request-management",
        icon: "mdi-clipboard-list-outline",
        to: "",
        subItems: [],
        order: 9,
    };

    static NavMessages = {
        id: "nav-message",
        title: "nav-message",
        icon: "mdi-comment-text-multiple-outline",
        to: "",
        subItems: [],
        order: 10,
    };
    //insert by me
    // static NavPublicAccess = {
    //     id: "nav-public-access",
    //     title: "nav-public-access",
    //     icon: "mdi-shield-account-outline",
    //     to: "",
    //     subItems: [],
    //     order: 11,
    // };
}

class Child {
    //insert by me
    // static AccessPublic = {
    //     id: "nav-public-access",
    //     title: "nav-public-access",
    //     icon: "",
    //     to: "accessPublic",
    //     subItems: [],
    //     order: 1,
    // };
    /** IO */
    static PeriodicIO = {
        id: "nav-interval-io",
        title: "nav-interval-io",
        icon: "",
        to: "interval-io",
        subItems: [],
        order: 1,
    };

    static MonthlyIO = {
        id: "nav-monthly-io",
        title: "nav-monthly-io",
        icon: "",
        to: "monthly-io",
        subItems: [],
        order: 2,
    };

    static IntervalIOReport = {
        id: "nav-interval-io-report",
        title: "nav-interval-io-report",
        icon: "",
        to: "interval-io-report",
        subItems: [],
        order: 3,
    };

    static MonthlyIOReport = {
        id: "nav-monthly-io-report",
        title: "nav-monthly-io-report",
        icon: "",
        to: "monthly-io-report",
        subItems: [],
        order: 4,
    };

    /** Functionality */
    static DailyFunctionality = {
        id: "nav-functionality-daily",
        title: "nav-functionality-daily",
        icon: "",
        to: "daily-functionality",
        subItems: [],
        order: 1,
    };
    static MonthlyFunctionalitys = {
        id: "nav-functionality-monthly",
        title: "nav-functionality-monthly",
        icon: "",
        to: "monthly-functionality",
        subItems: [],
        order: 2,
    };
    static PeriodicFunctionalitys = {
        id: "nav-functionality-periodic",
        title: "nav-functionality-periodic",
        icon: "",
        to: "periodic-functionality",
        subItems: [],
        order: 3,
    };

    /** My Request */
    static RequestLeave = {
        id: "nav-request-leave",
        title: "nav-request-leave",
        icon: "",
        to: "request-leave",
        subItems: [],
        order: 1,
    };
    static RequestMission = {
        id: "nav-request-mission",
        title: "nav-request-mission",
        icon: "",
        to: "request-mission",
        subItems: [],
        order: 2,
    };
    static RequestInOut = {
        id: "nav-request-io",
        title: "nav-request-io",
        icon: "",
        to: "request-io",
        subItems: [],
        order: 3,
    };
    static RequestInOutWithLocation = {
        id: "nav-request-io-location",
        title: "nav-request-io-location",
        icon: "",
        to: "request-io-location",
        subItems: [],
        order: 3,
    };
    static RequestExtraWork = {
        id: "nav-request-extra-work",
        title: "nav-request-extra-work",
        icon: "",
        to: "request-extra-work",
        subItems: [],
        order: 4,
    };
    static RequestLeaveArchive = {
        id: "nav-request-leave-archive",
        title: "nav-request-leave-archive",
        icon: "",
        to: "request-leave-archive",
        subItems: [],
        order: 5,
    };
    static RequestMissionArchive = {
        id: "nav-request-mission-archive",
        title: "nav-request-mission-archive",
        icon: "",
        to: "request-mission-archive",
        subItems: [],
        order: 6,
    };
    static RequestInOutArchive = {
        id: "nav-request-io-archive",
        title: "nav-request-io-archive",
        icon: "",
        to: "request-io-archive",
        subItems: [],
        order: 7,
    };
    static RequestExtraWorkArchive = {
        id: "nav-request-extra-work-archive",
        title: "nav-request-extra-work-archive",
        icon: "",
        to: "request-extra-work-archive",
        subItems: [],
        order: 8,
    };
    static RequestSpecificExtraWorkArchive = {
        id: "nav-request-specific-extra-work-archive",
        title: "nav-request-specific-extra-work-archive",
        icon: "",
        to: "request-specific-extra-work-archive",
        subItems: [],
        order: 9,
    };

    /** Private Cartable */
    static PrivateCartable = {
        id: "nav-private-cartable",
        title: "nav-private-cartable",
        icon: "mdi-view-dashboard",
        to: "private-cartable",
        subItems: [],
        order: 5,
    };

    /** Report Conflict */
    static ReportConflict = {
        id: "nav-report-conflict",
        title: "nav-report-conflict",
        icon: "mdi-robot-confused-outline",
        to: "report-conflict",
        subItems: [],
        order: 6,
    };

    /** Change Password */
    static ChangePassword = {
        id: "nav-change-password",
        title: "nav-change-password",
        icon: "mdi-lock-reset",
        class:"red",
        to: "change-password",
        subItems: [],
        order: 7,
    };

    /** Settings */
    static Settings = {
        id: "nav-settings",
        title: "nav-settings",
        icon: "mdi-tune",
        to: "settings",
        subItems: [],
        order: 8,
    };

    /**
     *  Messages
     */
    static Inbox = {
        id: "nav-inbox",
        title: "nav-inbox",
        icon: "",
        to: "inbox",
        subItems: [],
        order: 1,
    };
    static OutBox = {
        id: "nav-outbox",
        title: "nav-outbox",
        icon: "",
        to: "outbox",
        subItems: [],
        order: 2,
    };
    static SendMessage = {
        id: "nav-send-message",
        title: "nav-send-message",
        icon: "",
        to: "send-message",
        subItems: [],
        order: 3,
    };

    /**
     * PersonelOperationReport
     */

    static PresentPersonel = {
        id: "nav-present-personel",
        title: "nav-present-personel",
        icon: "",
        to: "present-personel",
        subItems: [],
        order: 1,
    };
    static IoInfoInDate = {
        id: "nav-ioinfoindate",
        title: "nav-ioinfoindate",
        icon: "",
        to: "ioinfoindate",
        subItems: [],
        order: 2,
    };
    static PersonelIoInfo = {
        id: "nav-personelioinfo",
        title: "nav-personelioinfo",
        icon: "",
        to: "personelioinfo",
        subItems: [],
        order: 3,
    };
    static PersonelDayWork = {
        id: "nav-personeldaywork",
        title: "nav-personeldaywork",
        icon: "",
        to: "personeldaywork",
        subItems: [],
        order: 4,
    };
    static PersonelMonthWork = {
        id: "nav-personelmonthwork",
        title: "nav-personelmonthwork",
        icon: "",
        to: "personelmonthwork",
        subItems: [],
        order: 5,
    };
    static PersonelPeriodWork = {
        id: "nav-personelperiodwork",
        title: "nav-personelperiodwork",
        icon: "",
        to: "personelperiodwork",
        subItems: [],
        order: 6,
    };
    static PersonelSection = {
        id: "nav-personel-section",
        title: "nav-personel-section",
        icon: "",
        to: "personel-section",
        subItems: [],
        order: 7,
    };
    static PersonelConflictReport = {
        id: "nav-personel-conflict-report",
        title: "nav-personel-conflict-report",
        icon: "",
        to: "personel-conflict-report",
        subItems: [],
        order: 8,
    };
    static AbsenceReport = {
        id: "nav-absence-report",
        title: "nav-absence-report",
        icon: "",
        to: "absence-report",
        subItems: [],
        order: 9,
    };
    static UnCompleteIoReport = {
        id: "nav-uncompleteio-report",
        title: "nav-uncompleteio-report",
        icon: "",
        to: "uncompleteio-report",
        subItems: [],
        order: 10,
    };
    static ExtraworkGroupRequest = {
        id: "nav-extrawork-group-request",
        title: "nav-extrawork-group-request",
        icon: "",
        to: "extrawork-group-request",
        subItems: [],
        order: 11,
    };
    static CompeleteIoSpecificDate = {
        id: "nav-compeleteio-specificdate",
        title: "nav-compeleteio-specificdate",
        icon: "",
        to: "compeleteio-specificdate",
        subItems: [],
        order: 12,
    };
    static CompeleteIo = {
        id: "nav-compeleteio",
        title: "nav-compeleteio",
        icon: "",
        to: "compeleteio",
        subItems: [],
        order: 13,
    };
    static AttendanceStatusReport = {
        id: "nav-attendance-status-report",
        title: "nav-attendance-status-report",
        icon: "",
        to: "attendance-status-report",
        subItems: [],
        order: 14,
    };
    /**
     * Request Management
     */
    static PersonelVacationView = {
        id: "nav-personel-vacation-view",
        title: "nav-personel-vacation-view",
        icon: "",
        to: "personel-vacation-view",
        subItems: [],
        order: 5,
    };
    static PersonelMissionView = {
        id: "nav-personel-mission-view",
        title: "nav-personel-mission-view",
        icon: "",
        to: "personel-mission-view",
        subItems: [],
        order: 6,
    };
    static PersonelIOView = {
        id: "nav-personel-io-view",
        title: "nav-personel-io-view",
        icon: "",
        to: "personel-io-view",
        subItems: [],
        order: 7,
    };
    static PersonelExtraWorkView = {
        id: "nav-personel-extrawork-view",
        title: "nav-personel-extrawork-view",
        icon: "",
        to: "personel-extrawork-view",
        subItems: [],
        order: 8,
    };
    static SpecificExtraWorkRequest = {
        id: "nav-specific-extrawork-request",
        title: "nav-specific-extrawork-request",
        icon: "",
        to: "specific-extrawork-request",
        subItems: [],
        order: 10,
    };
    static SpecificExtraWorkView = {
        id: "nav-specific-extrawork-view",
        title: "nav-specific-extrawork-view",
        icon: "",
        to: "specific-extrawork-view",
        subItems: [],
        order: 11,
    };
    static ApprovedVacationView = {
        id: "nav-aproved-Vacation-view",
        title: "nav-aproved-Vacation-view",
        icon: "",
        to: "aproved-Vacation-view",
        subItems: [],
        order: 12,
    };
    static AprovedMissionView = {
        id: "nav-aproved-Mission-view",
        title: "nav-aproved-Mission-view",
        icon: "",
        to: "aproved-Mission-view",
        subItems: [],
        order: 13,
    };
    static AprovedExtraWorkView = {
        id: "nav-aproved-ExtraWork-view",
        title: "nav-aproved-ExtraWork-view",
        icon: "",
        to: "aproved-ExtraWork-view",
        subItems: [],
        order: 14,
    };
}

class NavigationItems {
    constructor() { }

    items = [
        { 'id': 0, 'data': { "parent": Parent.NavProfile, "item": '' } },
        //insert by me
        // { 'id': 0, 'data': { "parent": Parent.NavPublicAccess, "item": Child.AccessPublic } },

        { 'id': 6, 'data': { "parent": Parent.NavIO, "item": Child.PeriodicIO } },
        { 'id': 17, 'data': { "parent": Parent.NavIO, "item": Child.MonthlyIO } },
        { 'id': 22, 'data': { "parent": Parent.NavIO, "item": Child.MonthlyIOReport } },
        { 'id': 23, 'data': { "parent": Parent.NavIO, "item": Child.IntervalIOReport } },

        { 'id': 7, 'data': { "parent": Parent.NavFunctinality, "item": Child.DailyFunctionality } },
        { 'id': 8, 'data': { "parent": Parent.NavFunctinality, "item": Child.MonthlyFunctionalitys } },
        { 'id': 9, 'data': { "parent": Parent.NavFunctinality, "item": Child.PeriodicFunctionalitys } },

        { 'id': 1, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestLeave } },
        { 'id': 1, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestLeaveArchive } },
        { 'id': 2, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestMission } },
        { 'id': 2, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestMissionArchive } },
        { 'id': 3, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestInOut } },
        { 'id': 27, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestInOutWithLocation } },
        { 'id': 3, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestInOutArchive } },
        { 'id': 4, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestExtraWork } },
        { 'id': 4, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestExtraWorkArchive } },
        { 'id': 26, 'data': { "parent": Parent.NavMyRequest, "item": Child.RequestSpecificExtraWorkArchive } },

        // { 'id': 10, 'data': { "parent": "", "item": Child.PrivateCartable } },
        { 'id': 18, 'data': { "parent": "", "item": Child.ReportConflict } },
        { 'id': 24, 'data': { "parent": "", "item": Child.ChangePassword } },
        { 'id': 25, 'data': { "parent": "", "item": Child.Settings } },

        /**
         * Messages
         */
        { 'id': 0, 'data': { "parent": Parent.NavMessages, "item": Child.Inbox } },
        { 'id': 159, 'data': { "parent": Parent.NavMessages, "item": Child.OutBox } },
        { 'id': 159, 'data': { "parent": Parent.NavMessages, "item": Child.SendMessage } },

        /**
         * RequestManagement
         */
        { 'id': 105, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().VacationManagement() } },
        { 'id': 105, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().AdminApprovalLevelInfo() } },
        { 'id': 107, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().MissionManagement() } },
        { 'id': 107, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().AdminApprovalLevelInfo() } },
        { 'id': 109, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().IOManagement() } },
        { 'id': 109, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().AdminApprovalLevelInfo() } },
        { 'id': 110, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().ExtraWorkManagement() } },
        { 'id': 110, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().AdminApprovalLevelInfo() } },

        { 'id': 154, 'data': { "parent": Parent.NavRequestManagement, "item": Child.PersonelVacationView } },
        { 'id': 155, 'data': { "parent": Parent.NavRequestManagement, "item": Child.PersonelMissionView } },
        { 'id': 156, 'data': { "parent": Parent.NavRequestManagement, "item": Child.PersonelIOView } },
        { 'id': 157, 'data': { "parent": Parent.NavRequestManagement, "item": Child.PersonelExtraWorkView } },

        { 'id': 163, 'data': { "parent": Parent.NavRequestManagement, "item": Child.SpecificExtraWorkRequest } },
        // { 'id': 163, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().ExtraWorkSpecificManagement() } },
        { 'id': 163, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().AdminApprovalLevelInfo() } },
        // { 'id': 164, 'data': { "parent": Parent.NavRequestManagement, "item": Child.SpecificExtraWorkView } },
        { 'id': 164, 'data': { "parent": Parent.NavRequestManagement, "item": new RequestManagement().ExtraWorkSpecificManagement() } },
        // Add by saeedi approved page
        { 'id': 118, 'data': { "parent": Parent.NavRequestManagement, "item": Child.ApprovedVacationView } },
        { 'id': 122, 'data': { "parent": Parent.NavRequestManagement, "item": Child.AprovedExtraWorkView } },
        { 'id': 119, 'data': { "parent": Parent.NavRequestManagement, "item": Child.AprovedMissionView } },

        /**
         * PersonelOperationReport
         */
        { 'id': 112, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.PresentPersonel } },
        { 'id': 111, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.IoInfoInDate } },
        { 'id': 116, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.PersonelIoInfo } },
        { 'id': 113, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.PersonelDayWork } },
        { 'id': 114, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.PersonelMonthWork } },
        { 'id': 115, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.PersonelPeriodWork } },
        { 'id': 145, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.PersonelSection } },
        { 'id': 149, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.PersonelConflictReport } },
        { 'id': 117, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.AbsenceReport } },
        { 'id': 142, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.UnCompleteIoReport } },
        { 'id': 151, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.ExtraworkGroupRequest } },
        { 'id': 152, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.CompeleteIoSpecificDate } },
        { 'id': 153, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.CompeleteIo } },
        { 'id': 160, 'data': { "parent": Parent.NavPersonelOperationReport, "item": Child.AttendanceStatusReport } },
    ]

}

const NavigationList = []

const Navigation = {
    getNavigationList(array = []) {
        array.push(0)
        NavigationList.forEach((item) => item.subItems.splice(0))
        NavigationList.splice(0)

        //this.getParent(Parent.NavProfile)
        //console.log(array);

        array.forEach((number) => {
            ////console.log(number);
            var navigationItems = new NavigationItems().items
            var items = navigationItems.filter((item) => {
                return item.id === number
            })
            ////console.log(items);
            if (items.length > 0) {
                items.forEach((item) => {
                    ////console.log(item.id);
                    var navItem = item.data.item
                    if (item.data.parent != "") {
                        var parent = this.getParent(item.data.parent)
                        if (navItem != '') {
                            //check duplicate
                            var duplicate = parent.subItems.find((element) => {
                                return element.id === navItem.id
                            })
                            if (!duplicate) {
                                parent.subItems.push(navItem);
                            } else {
                                ////console.log('duplicate:',duplicate);
                            }
                        }
                    } else {
                        if (navItem != '') {
                            NavigationList.push(navItem)
                        }
                    }
                });
            }
            /*var item = NavigationItems.find((item) => item.id === number);
            if (item != null) {
                ////console.log(item.id);
                var navItem = item.data.item
                if (item.data.parent != "") {
                    var parent = this.getParent(item.data.parent)
                    if (navItem != '') {
                        parent.subItems.push(navItem);
                    }
                } else {
                    if (navItem != '') {
                        NavigationList.push(navItem)
                    }
                }

            }*/
        })
        //this.getParent(Parent.NavLogout)

        this.sortListByOrder(NavigationList)

        if (!PersonelsUtils.CheckEmployementDate()) {
            var navMyRequestIndex = NavigationList.findIndex(item => item.id == 'nav-my-request')
            if (navMyRequestIndex >= 0) {
                NavigationList.splice(navMyRequestIndex, 1)
            }
        }

        var navMyRequest = NavigationList.find(item => item.id == Parent.NavMyRequest.id)
        //console.log(NavigationList);
        console.log(navMyRequest);
        if (navMyRequest) {
            var GeoFenceCount = store.state.lock.lockData.GeoFenceCount;

            if (isMobile(window.navigator).any && GeoFenceCount && Number(GeoFenceCount) > 0 && array.includes(27)) {
                //AddIoWithLocation();
                var navRequestIOWithoutLocation = navMyRequest.subItems.findIndex(item => item.id == Child.RequestInOut.id)
                if (navRequestIOWithoutLocation >= 0) {
                    navMyRequest.subItems.splice(navRequestIOWithoutLocation, 1)
                }
            } else {
                //addIOWithoutLocation();
                var navRequestIOWithLocation = navMyRequest.subItems.findIndex(item => item.id == Child.RequestInOutWithLocation.id)
                if (navRequestIOWithLocation >= 0) {
                    navMyRequest.subItems.splice(navRequestIOWithLocation, 1)
                }
            }

        }

        var lockData = store.state.lock.lockData
        //console.log(lockData);
        if (lockData.HasMorkhasiMamooriat != "True") {
            var _navMyRequestIndex = NavigationList.findIndex(item => item.id == 'nav-my-request')
            if (_navMyRequestIndex >= 0) {
                NavigationList.splice(_navMyRequestIndex, 1)
            }

            var _navRequestManagementIndex = NavigationList.findIndex(item => item.id == Parent.NavRequestManagement.id)
            if (_navRequestManagementIndex >= 0) {
                NavigationList.splice(_navRequestManagementIndex, 1)
            }
        }

        return NavigationList;
    },
    sortListByOrder(list) {
        if (list) {
            list.sort((a, b) => {
                ////console.log(a);
                return (a.order > b.order) ? 1 : -1
            })

            list.forEach((item) => {
                if (item.subItems.length > 0) {
                    this.sortListByOrder(item.subItems)
                }
            })
        }
    },
    getParent(parent) {
        var _parent = NavigationList.find((item) => item.id === parent.id);
        if (_parent != null) {
            return _parent;
        } else {
            NavigationList.push(parent)
            return parent;
        }
    },
}
export default Navigation;